<template>
  <div id="portraits" class="sub-section">
    <div class="portrait" v-for="(member, index) in team" :key="index">
      <video playsinline autoplay muted loop id="video">
          <source :src="`${member.vid}`" type="video/mp4" />
      </video>
      <div class="member-desc">
        <h3>{{ member.name }}</h3>
        <a :href="`mailto:${member.mail}`">{{ member.mail }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    team() {
      return this.$store.state.team;
    },
  },
};
</script>

<style lang="scss" scoped>
#portraits {
  display: flex;
  justify-content: space-between;
  padding: 5vh 0 12vh 0;
  .portrait {
    width: 16.6vw;
    background-color: #ebebeb;
    padding: 2vw;
    border-radius: 15px;
    text-align: center;
    video {
      width: 9vw;
      border-radius: 1000px;
    }
    .member-desc {
      h3 {
        padding: 2rem 0 .8rem 0;
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: 0.1rem;
      }
      a {
        font-weight: 400;
        line-height: 2rem;
        text-decoration: none;
        color: #1f2d35;
        &:hover {
          text-decoration: underline #1f2d35;
        }
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .sub-section {
    padding: 0 0 6vh 0;
  }
  #portraits {
    flex-direction: column;
    .portrait {
      width: 80vw;
      border-radius: 200px;
      margin-bottom: 5vw;
      display: flex;
      align-items: center;
      justify-content: space-between;
      video {
        width: 25vw;
      }
      .member-desc {
        text-align: left;
        padding-right: 15vw;
        h3 {
          padding: 0 0 1.5rem 0;
        }
      }
    }
  }
}
</style>
